import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useSearchParams } from "react-router-dom";
import { useFormsFilters } from "../hooks/useFormsFilters";
import moment, { type Moment } from "moment";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const StartFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const { start: Start, end: End } = useFormsFilters();

	const handleDateChange = (datePicker: Moment | null) => {
		if (datePicker && datePicker.toDate() > End) {
			return;
		}

		searchParams.set("start", encodeURIComponent(datePicker!.toISOString()));
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				format="MM/DD/YYYY"
				label="Start"
				value={moment(Start)}
				onChange={handleDateChange}
				maxDate={moment(End)}
				slotProps={{
					textField: {
						fullWidth: true,
						variant: "outlined",
						margin: "dense",
						InputProps: {
							style: {
								height: cmmsTheme.dimensions.standardInput,
								marginTop: cmmsTheme.spacing.inputOffset,
							},
						},
						InputLabelProps: {
							style: {
								fontSize: "14px",
							},
						},
					},
				}}
			/>
		</LocalizationProvider>
	);
};
